import React from "react"
import { Container, Row } from "./ShippingComponents.styled"
import ListEntry from "../Ui/ListEntry"
import { ShippingFee } from "lib/types/generated/graphql-types"
import { Maybe } from "@graphql-tools/utils"
import Dinero from "dinero.js"
import DineroFactory from "dinero.js"
import dayjs from "dayjs"
import LargeTotal from "../Ui/LargeTotal"
import { Percentage } from "helpers/Percentage"

type Props = {
  shippingFees?: Maybe<ShippingFee[]> | undefined
  currencyCode: string
  date: string
}

const ShippingTotals = ({ shippingFees, currencyCode, date }: Props) => {

  if(shippingFees?.length === 0) return null
  return (
    <Container>
      {shippingFees?.map((fee) => {
        const percentage = new Percentage(fee.taxPercentage ?? 0, fee.taxPercentageDecimals ?? 0)
        return (
          <React.Fragment key={fee?.id}>
            <Row $templateColumns={"2fr 2fr 1fr"}>
              <ListEntry label={"Order date"} value={dayjs(date).format("YYYY-MM-DD")} />
              <ListEntry label={"Shipping tax rate"} value={percentage.formatPercentage()} />
              <ListEntry
                label={"Shipping tax"}
                value={Dinero({
                  amount: fee.taxAmount ?? 0,
                  currency: currencyCode as DineroFactory.Currency
                }).toFormat()}
              />
            </Row>
            <LargeTotal
              label={"Total shipping cost"}
              value={Dinero({
                amount: fee.salePriceAmount ?? 0,
                currency: currencyCode as DineroFactory.Currency
              }).toFormat()}
            />
          </React.Fragment>
        )
      })}
    </Container>
  )
}

export default ShippingTotals
